import React, { useState, useEffect } from "react";

import { func_validation, isArrayNotEmpty, isFunction, isNotNullUndefined, isStringEqual_caseSensitive, isStringTrimNotEmpty } from "functions";

import ic_small_add from "assets/images/ic_small_add.svg";
import ic_small_save from "assets/images/ic_small_save.svg";
import { Toaster } from "components/notification/Toaster";

export function useSubmission(props) {
    const {
        isEditing,

        isEveryInputValid, isAnyInputChanged,

        referenceValue, productCode, companyId,

        companyDetails, productDetails,
        chargeDetails, miscellaneousDetails,
        billingSetupDiscountsDetails,
        sideDetails,

        isFormSubmissionAttempted,

        billingSetup: billingSetup_original,

        isAccountRecordUpdatedSuccessfully,

        // Function
        updateRemarks
    } = props;

    // Submits
    let submitIcon = isEditing? ic_small_save: ic_small_add;
    let submitText = isEditing? "Save": "Add";
    let submitAltText = isEditing? "Save Icon": "Add Icon";
    function handleSubmission() {
        let billingSetupId = func_validation.getObjectPropertyValue(billingSetup_original, "Id");

        if (isAnyInputChanged) {
            if ((!isEditing || 
                    (isEditing && func_validation.isNumberValid(billingSetupId))) &&
                isEveryInputValid) {

                let referenceValues_formatted = func_validation.getTrimmedString(referenceValue, "");
                let referenceValueArray = referenceValues_formatted.split("\n");
                let billingSetupId_validated = (func_validation.isNumberValid(billingSetupId) && isEditing)? billingSetupId:0;

                let billingSetup = func_validation.combineObjects([
                    { Id: billingSetupId_validated, IsSuspense: false },
                    companyDetails, productDetails, 
                    chargeDetails, miscellaneousDetails,
                    sideDetails
                ]);
                
                // Add BillingSetupDiscounts if available
                if (func_validation.isArrayNotEmpty(billingSetupDiscountsDetails)) {
                    billingSetup["BillingSetupDiscounts"] = billingSetupDiscountsDetails;
                }
                

                if (func_validation.isArrayNotEmpty(referenceValueArray)) {
                    let billingSetupDetails = [];
                    let billingSetupDetails_original = billingSetup_original?.BillingSetupDetails;

                    referenceValueArray.map((referenceValue, idx) => {
                        // Get billing setup detail id & reference key
                        let billingSetupDetails_id = 0;
                        let biilingSetupDetails_referenceKey = "";
                        if (isArrayNotEmpty(billingSetupDetails_original) && isEditing) {
                            billingSetupDetails_original.map((details) => {
                                let id = details?.Id;
                                let referenceKey = details?.ReferenceKey;
                                let referenceValue_original = details?.ReferenceValue;

                                if (isStringEqual_caseSensitive(referenceValue_original, referenceValue)) {
                                    billingSetupDetails_id = id;
                                    biilingSetupDetails_referenceKey = referenceKey;
                                }
                            })
                        }

                        if (func_validation.isStringTrimNotEmpty(referenceValue)) {
                            let billingSetupDetailsItem = {
                                Id: billingSetupDetails_id,
                                BillingSetupId: billingSetupId_validated,
                                CompanyId: companyId,
                                ProductCode: productCode,
                                ReferenceKey: biilingSetupDetails_referenceKey,
                                ReferenceValue: referenceValue
                            };

                            billingSetupDetails.push(billingSetupDetailsItem);
                        }
                    });

                    if (func_validation.isArrayNotEmpty(billingSetupDetails))
                        billingSetup["BillingSetupDetails"] = billingSetupDetails;
                }
                
                if (isEditing && props.updateAccount) 
                    props.updateAccount(billingSetup);
                else if (props.addAccount) 
                    props.addAccount(billingSetup);

                // Remark API
                if (isFunction(updateRemarks) &&
                    isStringTrimNotEmpty(companyDetails?.AccountCode) &&
                    isNotNullUndefined(miscellaneousDetails?.Remarks)) {
                    
                    updateRemarks({
                        accountCode: companyDetails?.AccountCode,
                        note: miscellaneousDetails?.Remarks
                    });
                }
            }
            else {
                Toaster({
                    type: "error",
                    msg: "Invalid input(s)"
                })
            }
        }
        else {
            Toaster({
                type: "info",
                msg: "No input changed"
            })
        }
        
        if (func_validation.isFunction(props.setFormSubmissionStatus))
            props.setFormSubmissionStatus(true);
    }
    function handleSuccessfulSubmission() {
        if (isAccountRecordUpdatedSuccessfully &&
            isFormSubmissionAttempted &&
            props.updateParentState_visiblity)
            props.updateParentState_visiblity(false);
    }
    useEffect(() => {
        handleSuccessfulSubmission();
    }, [isAccountRecordUpdatedSuccessfully]);

    return {
        submitIcon, submitText, submitAltText,
        isEveryInputValid, handleSubmission
    }
}